import FdeSelect from '@/frontend/features/Fde/FdeSelect'
import TaskCategoriesManager from '@/frontend/features/Fde/TaskCategoriesManager'
import type { ManagementProps } from '@/frontend/features/Fde/managementTypes'

interface Props {
  props: ManagementProps
  groupBy: string
  onGroup: (value: 'status' | 'category') => void
  showChildren: boolean
  onChildren: (value: boolean) => void
  allowChildrenToggle?: boolean
}
export default function TaskOrganizationToolbar({
  props,
  groupBy,
  onGroup,
  showChildren,
  onChildren,
  allowChildrenToggle = true,
}: Props) {
  const copy = props.copy.management
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-xs">
      <FdeSelect
        value={groupBy}
        ariaLabel={copy.group_tasks}
        onValueChange={(value) => onGroup(value as 'status' | 'category')}
        options={[
          { value: 'status', label: copy.group_by_status },
          { value: 'category', label: copy.group_by_category },
        ]}
        size="sm"
        className="h-7 w-40 text-xs"
      />
      {allowChildrenToggle && (
        <label className="flex cursor-pointer items-center gap-2 text-muted-foreground">
          <input
            type="checkbox"
            checked={showChildren}
            onChange={(event) => onChildren(event.target.checked)}
            className="size-3.5 accent-primary"
          />
          {copy.show_subtasks}
        </label>
      )}
      {props.can_manage && (
        <TaskCategoriesManager
          key={props.project!.id}
          projectId={props.project!.id}
          categories={props.task_categories ?? []}
          copy={copy}
        />
      )}
    </div>
  )
}
